import React, { useEffect, useState } from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../../auth/logic/authProvider';
import { ProjectRepository } from '../../project/data/projectRepository';
import { TimesheetProvider } from '../../timesheet/logic/timesheetProvider';
import TimesheetsPage from '../../timesheet/ui/TimesheetsPage';
import { useTheme } from '../../../shared/theme/ThemeContext';
import Routes from '../../../shared/routing/routes';
import './TaskTimesheetsPage.css';

const TaskTimesheetsPage = () => {
  const { taskId } = useParams();
  const { state } = useLocation();
  const { user } = useAuth();
  const { theme } = useTheme();
  const [task, setTask] = useState(state?.task ?? null);

  useEffect(() => {
    if (task?.name) return undefined;

    let cancelled = false;
    const loadTask = async () => {
      try {
        const tasks = await ProjectRepository.listTasks({ accessToken: user?.accessToken });
        const nextTask = tasks.find((item) => String(item.id) === String(taskId));
        if (!cancelled && nextTask) setTask(nextTask);
      } catch {
        if (!cancelled) setTask(null);
      }
    };

    loadTask();
    return () => {
      cancelled = true;
    };
  }, [task?.name, taskId, user?.accessToken]);

  return (
    <div className="task-timesheets-page" style={{ color: theme.text }}>
      <div className="task-timesheets-page__nav">
        <Link to={Routes.home} style={{ color: theme.primary }}>
          Back to home
        </Link>
      </div>
      <TimesheetProvider>
        <TimesheetsPage
          fixedTaskId={taskId}
          fixedTaskName={task?.name}
          initialTablePeriod="month"
          initialView="list"
          showFilters={false}
          title={task?.name || 'Task Timesheets'}
        />
      </TimesheetProvider>
    </div>
  );
};

export default TaskTimesheetsPage;
